// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.page {\n  background-color: #f7f8fa;\n  position: absolute;\n  width: 100%;\n  min-height: 100%;\n  padding: 8px;\n}\n\n\n.keyword {\n  color: #0088FF\n}", ""]);
// Exports
module.exports = exports;
